module.exports = __webpack_public_path__ + "img/no-inventory.7cac4168.png";